import { FilterBase } from './FilterBase';


export class FilterUser extends FilterBase {
        
    public enseigneIds:Array<number>
    public roleKeys:Array<string>
    
    constructor({enseigneIds = [] as Array<number>,roleKeys = [] as Array<string>,...args}= {}) {        
        super(args)
        this.enseigneIds = enseigneIds
        this.roleKeys = roleKeys
    }
}
